import { Validator } from '@vista-digital/validator';
import { getUniquenessValidator } from '../../utils/validators/uniqueness-validator';
import { apiConfigValidator, defaultApiConfig } from './api';
import { browsingConfigValidator, defaultBrowsingConfig } from './browsing';
import { cacheConfigValidator, defaultCacheConfig } from './cache/cache';
import { cdnConfigValidator, defaultCdnConfig } from './cdn';
import { cxmConfigValidator, defaultCxmConfig } from './cxm';
import { defaultLanguage, languageValidator } from './language';
import { defaultLoggerConfig, loggerConfigValidator } from './logger';
import { defaultLoyaltyConfig, loyaltyConfigValidator } from './loyalty/loyalty';
import { defaultOrderConfig, orderConfigValidator } from './order/order';
import { defaultTicketRedemptionCodeTypes, ticketRedemptionCodeTypeValidator } from './ticket-redemption-codes/ticket-redemption-code-type';
export const defaultDomainConfig = {
    api: defaultApiConfig,
    browsing: defaultBrowsingConfig,
    cache: defaultCacheConfig,
    cdn: defaultCdnConfig,
    cxm: defaultCxmConfig,
    languages: [defaultLanguage],
    logger: defaultLoggerConfig,
    loyalty: defaultLoyaltyConfig,
    order: defaultOrderConfig,
    ticketRedemptionCodeTypes: defaultTicketRedemptionCodeTypes
};
export const domainConfigValidator = Validator.object({
    api: apiConfigValidator,
    browsing: browsingConfigValidator,
    cache: cacheConfigValidator,
    cdn: cdnConfigValidator,
    cxm: cxmConfigValidator,
    languages: Validator.array({ minLength: 1, items: languageValidator }),
    logger: loggerConfigValidator,
    loyalty: loyaltyConfigValidator,
    order: orderConfigValidator,
    ticketRedemptionCodeTypes: Validator.all([
        Validator.array({ minLength: 1, items: ticketRedemptionCodeTypeValidator }),
        getUniquenessValidator('id')
    ])
});
